import { roundNumber } from '@/helpers'
export default function(value) {
  if (value < 1000) {
    return `${roundNumber(value, 3)} ${this.$t('units.weight.kg')}`
  } else {
    return `${roundNumber(value / 1000, 3)}  ${this.$t('units.weight.t')}`
  }
}
